// components/Breadcrumbs.js

import Link from 'next/link';

const Breadcrumbs = ({ paths }) => {

    return (
        <div style={{marginBottom: "20px"}}>
            {paths?.map((path, index) => (
                <span key={index} >
                     {path.url ? (
                         <Link href={path.url}>
                             <span style={{color:"red"}}>{path.name}</span>
                         </Link>
                     ) : (
                         <span style={{color:"black"}}>{path.name}</span>
                     )}
                    {index < paths.length - 1 && ' > '}
                </span>
            ))}
        </div>
    );
};

export default Breadcrumbs;